import { render, staticRenderFns } from "./HotelTags.vue?vue&type=template&id=3e43168e&scoped=true"
import script from "./HotelTags.vue?vue&type=script&lang=js"
export * from "./HotelTags.vue?vue&type=script&lang=js"
import style0 from "./HotelTags.vue?vue&type=style&index=0&id=3e43168e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43168e",
  null
  
)

export default component.exports